<template>
  <div>

      <formCampaign 
        :title="'CREATE A CAMPAIGN'" 
        :data=dataCampaignInfo 
        @onCancel="cancelEditCampaign" 
        :goToStep=selectStepEdit
        @onSave="formSave"
        @onSaveToDraft="saveDraft"
        @onSendToApprove="sendToApprove"
        :Mode="'create'"
      >
      </formCampaign>
      <!-- {{dataCampaignInfo}} -->
  </div>
</template>

<script>
import formCampaign from "./share/form-campaign/form-campaign";
import CampaignService from "@/services/campaign";

export default {
  name: "campaign-manage",
  components: {
    formCampaign
  },
  data() {
    return {
      dataCampaignInfo : {
        campaign_code: null,
        campaign_title: null,
        campaign_detail: null,
        startdate: null,
        enddate: null,
        campaign_active: true,
        campaign_status: null,
        campaign_deleted: false,
        rank_value: {},
        products: [],
        join_within: 0,
        sets: [
          {
            name: "",
            point: {start:null,end:null},
            rewards: [],
            customers: []
          }]
      },
      selectStepEdit: 1
    }
  },
  methods:{
    cancelEditCampaign(){

    },
    formSave(dataCamp){
        if(dataCamp.sets[0].name == '') dataCamp.sets[0].name = 'SET 1';
        CampaignService.createCampaign(dataCamp).then(response =>{
           this.$router.push('/campaign/manage')
        })
    },
    saveDraft(dataCamp){
      if(dataCamp.sets[0].name == '') dataCamp.sets[0].name = 'SET 1';
      dataCamp.campaign_status = 'Draft';
      CampaignService.createCampaign(dataCamp).then(response =>{
          this.$router.push('/campaign/manage')
      })
    },
    sendToApprove(dataCamp){
      dataCamp.campaign_status = 'Pending';
      CampaignService.createCampaign(dataCamp).then(response =>{
          this.$router.push('/campaign/manage')
      })
    }
  }
}

</script>

<style lang="scss" scoped>


</style>